"use client";

import * as amplitude from "@amplitude/analytics-browser";

// Esta función simplemente llama a los eventos de Google Analytics y Hotjar
// para rastrear eventos en la aplicación.

/**
 * Función reutilizable de PLAVED para rastrear eventos personalizados de los usuarios. Se utilizará para combinar los eventos de la sesión de Replay con los eventos de Amplitude.
 * 
 * @param {string} eventName - Nombre del evento.
 * @param {Object} eventProperties - Propiedades adicionales del evento.
 */
export const trackEvent = (eventName, eventProperties = {}) => {
  try {
    // Verificar que estamos en el navegador
    if (typeof window === 'undefined') return;

    // Asegurarse de que amplitude está disponible
    if (amplitude && amplitude.track) {
      // Enviar evento a Amplitude
      amplitude.track(eventName, {
        ...eventProperties,
      });
    }

    // Solo mostrar logs en entorno de desarrollo
    if (process.env.NODE_ENV === 'development') {
      console.log(`Evento rastreado: ${eventName}`, { ...eventProperties });
    }
  } catch (error) {
    console.error("Error rastreando el evento:", error);
  }
  
  // Importante: siempre devolver false para prevenir comportamiento de formulario
  return false;
};